<template>
  <div id="main" class="about">
    <h1>このサイトについて</h1>
    <p>ポストエクスプレス<span>&reg;</span>WEB（栃木県央版）は、<a href='https://www.alliance-web.jp/' target='_blank'>PEアライアンス株式会社</a>が運営しています。</p>
    <p>ポストエクスプレス栃木支社 Powered by 株式会社アシストパル</p>
    <p>Version {{ version }}</p>
    <router-link to="/"><el-button type="primary" round>栃木県央版TOPに戻る</el-button></router-link>
    <p><a href="https://pe.alliance-web.jp">pe.alliance-web.jp</a></p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { version } from '../../package.json';

export default defineComponent({
  setup() {
    return {
      version
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #43b665;
}
span {
  vertical-align: super;
  font-size: smaller;
}
</style>
